import state    from './state';

export default {
    getProfile:         () => state.profile || [],
    getUploadProgress:  () => state.uploadProgress || 0,    
    isProfileComplete:  () => state.is_profile_complete || false,
}